import { Link } from "@tanstack/react-router";

interface NotFoundPageProps {
  path?: string;
}

export function NotFoundPage({ path }: NotFoundPageProps) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      <div className="font-mono text-xs font-semibold uppercase tracking-[0.12em] text-accent">
        404 · NOT FOUND
      </div>
      <h1 className="mt-3 text-2xl font-bold tracking-tight text-ink">Page not found</h1>
      {path && (
        <p className="mt-2 text-sm text-muted">
          The page{" "}
          <code className="rounded bg-code-bg px-1.5 py-0.5 font-mono text-xs">{path}</code>{" "}
          doesn&apos;t exist.
        </p>
      )}
      <div className="mt-6 flex items-center gap-3">
        <Link
          to="/overview"
          className="rounded-md bg-navy px-4 py-2 font-mono text-xs font-medium text-white transition-colors hover:bg-navy/90"
        >
          Go to Overview
        </Link>
        <button
          onClick={() => window.history.back()}
          className="rounded-md border border-line bg-surface px-4 py-2 font-mono text-xs font-medium text-ink transition-colors hover:bg-code-bg"
          type="button"
        >
          Back
        </button>
      </div>
    </div>
  );
}
